"use strict";

require("core-js/modules/es.array.reduce.js");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureForm = configureForm;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));
/* global process */


var notInProd = function notInProd(cb) {
  if (process && process.env.NODE_ENV !== 'production') {
    cb();
  }
};

var initialFieldState = function initialFieldState(value) {
  return {
    value: value,
    isDirty: false,
    error: undefined,
    valueType: (0, _typeof2.default)(value)
  };
};

var initialiseFormFields = function initialiseFormFields(initialData) {
  return Object.keys(initialData).reduce(function (acc, key) {
    acc[key] = initialFieldState(initialData[key]);
    return acc;
  }, {});
};

var updateFormFieldErrors = function updateFormFieldErrors(state, errors) {
  return Object.keys(state).reduce(function (acc, key) {
    acc[key] = (0, _objectSpread3.default)({}, state[key], {
      error: errors[key]
    });
    return acc;
  }, {});
};

function objectHasKeys(errorObj) {
  return Object.keys(errorObj).length > 0;
}

var getFormFieldsValues = function getFormFieldsValues(state) {
  return Object.keys(state).reduce(function (acc, key) {
    acc[key] = state[key].value;
    return acc;
  }, {});
};

var getFormFieldsErrors = function getFormFieldsErrors(state) {
  return Object.keys(state).reduce(function (acc, key) {
    if (state[key].error) {
      acc[key] = state[key].error;
    }

    return acc;
  }, {});
};

var forceValueType = function forceValueType(value, type) {
  switch (type) {
    case 'string':
      return value.toString();

    case 'boolean':
      return /^true|false$/.test(value) ? eval(value) : Boolean(value);

    case 'number':
      return Number(value);
    // TODO: are there other types we want to handle here?
    // Dates maybe..

    default:
      return value;
  }
};

function configureForm(_ref) {
  var initFields = _ref.initFields,
      submit = _ref.submit,
      _ref$validate = _ref.validate,
      validate = _ref$validate === void 0 ? function () {
    return {};
  } : _ref$validate,
      onChange = _ref.onChange,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      onReset = _ref.onReset,
      onFirstInteraction = _ref.onFirstInteraction,
      displayName = _ref.displayName,
      _ref$onSubmitStopProp = _ref.onSubmitStopPropagation,
      onSubmitStopPropagation = _ref$onSubmitStopProp === void 0 ? false : _ref$onSubmitStopProp;
  var config = {
    initFields: initFields,
    submit: submit,
    validate: validate,
    displayName: displayName,
    onSubmitStopPropagation: onSubmitStopPropagation
  };
  var callbacks = {
    onChange: onChange,
    onSuccess: onSuccess,
    onError: onError,
    onReset: onReset,
    onFirstInteraction: onFirstInteraction
  };
  return function decorator(WrappedComponent) {
    var _class, _temp;

    var componentDisplayName = config.displayName || "PragmaticForm(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    return _temp = _class = /*#__PURE__*/function (_Component) {
      (0, _inherits2.default)(PragmaticForm, _Component);

      function PragmaticForm(_props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, PragmaticForm);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PragmaticForm).call(this, _props, context));
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
          formFields: {},
          isPristine: true,
          isLoading: false,
          submitResult: undefined,
          submitError: undefined
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "fieldProps", {});
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getFormFieldsValues", function () {
          return getFormFieldsValues(_this.state.formFields);
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updateField", function (name, value) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var _this$state = _this.state,
              formFields = _this$state.formFields,
              isPristine = _this$state.isPristine;
          var fieldItem = formFields[name];
          var newValue = value;

          if (options.forceType) {
            newValue = forceValueType(value, options.forceType);
          } else {
            notInProd(function () {
              if (fieldItem.valueType !== (0, _typeof2.default)(value)) {
                console.warn( // eslint-disable-line no-console
                "Value type of \"".concat(name, "\" has changed from \"").concat(fieldItem.valueType, "\" to \"").concat((0, _typeof2.default)(value), "\""), 'Use `forceType` to coerce the value to a supported type.');
              }
            });
          }

          if (isPristine) {
            _this.callCallback('onFirstInteraction', _this.getFormFieldsValues);
          }

          _this.setState({
            formFields: (0, _objectSpread3.default)({}, formFields, (0, _defineProperty2.default)({}, name, (0, _objectSpread3.default)({}, fieldItem, {
              value: newValue,
              error: undefined,
              isDirty: true
            }))),
            isPristine: false,
            submitError: undefined
          });
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_createInputOnChange", function (name, options) {
          return function (event) {
            var field = event.currentTarget;

            if (field.files && field.multiple) {
              _this.updateField(name, field.files, options);
            } else if (field.files) {
              _this.updateField(name, field.files[0], options);
            } else {
              _this.updateField(name, field.value, options);
            }
          };
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_createCheckOnChange", function (name, options) {
          return function (event) {
            _this.updateField(name, event.currentTarget.checked, options);
          };
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_getFieldValueWithDefault", function (name, defaultValue) {
          if (_this.state.formFields[name]) {
            return _this.state.formFields[name].value;
          } else {
            return defaultValue;
          }
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "formInputProps", function (options) {
          var name = options.name,
              type = options.type,
              value = options.value,
              multiple = options.multiple,
              checked = options.checked,
              changeOpts = (0, _objectWithoutProperties2.default)(options, ["name", "type", "value", "multiple", "checked"]);

          if (!_this.fieldProps[name]) {
            _this.fieldProps[name] = {
              name: name,
              type: type,
              onChange: type === 'checkbox' ? _this._createCheckOnChange(name, changeOpts) : _this._createInputOnChange(name, changeOpts)
            };
          }

          var disabled = _this.state.isLoading;

          switch (type) {
            case 'checkbox':
              return Object.assign(_this.fieldProps[name], {
                checked: _this._getFieldValueWithDefault(name, checked),
                // This defaults to not checked
                disabled: disabled
              });

            case 'radio':
              return Object.assign(_this.fieldProps[name], {
                checked: _this._getFieldValueWithDefault(name, value) === value,
                value: value,
                disabled: disabled
              });

            case 'file':
              if (multiple) {
                return Object.assign(_this.fieldProps[name], {
                  files: _this._getFieldValueWithDefault(name, value),
                  multiple: multiple,
                  disabled: disabled
                });
              } else {
                return Object.assign(_this.fieldProps[name], {
                  files: [_this._getFieldValueWithDefault(name, value)],
                  disabled: disabled
                });
              }

            default:
              return Object.assign(_this.fieldProps[name], {
                value: _this._getFieldValueWithDefault(name, value),
                disabled: disabled
              });
          }
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "formFieldProps", function (options) {
          var inputProps = _this.formInputProps(options);

          var fieldState = _this.state.formFields[options.name];
          return Object.assign(inputProps, {
            error: fieldState.error,
            isDirty: fieldState.isDirty,
            onValueChange: function onValueChange(value) {
              return _this.updateField(options.name, value);
            }
          });
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "formComponentProps", function () {
          return {
            onSubmit: _this.handleSubmit,
            onReset: _this.handleReset
          };
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "submit", function () {
          return _this.handleSubmit();
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "reset", function () {
          return _this.handleReset();
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "formComponent", function (props) {
          return _react.default.createElement("form", (0, _extends2.default)({}, props, {
            onSubmit: _this.handleSubmit,
            onReset: _this.handleReset
          }));
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleSubmit", /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(event) {
            var formData, errors, _result;

            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    event && event.preventDefault();
                    config.onSubmitStopPropagation && event && event.stopPropagation();
                    formData = _this.getFormFieldsValues();
                    errors = config.validate(formData, _this.props, _this.formProps());

                    if (!objectHasKeys(errors)) {
                      _context.next = 6;
                      break;
                    }

                    return _context.abrupt("return", _this.setState({
                      formFields: updateFormFieldErrors(_this.state.formFields, errors)
                    }));

                  case 6:
                    _this.setState({
                      isLoading: true
                    });

                    _context.prev = 7;
                    _context.next = 10;
                    return config.submit(formData, _this.props, _this.formProps());

                  case 10:
                    _result = _context.sent;

                    _this.setState({
                      isLoading: false,
                      submitResult: _result
                    }, function () {
                      _this.callCallback('onSuccess', _result);
                    });

                    _context.next = 17;
                    break;

                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](7);

                    _this.setState({
                      isLoading: false,
                      submitError: _context.t0
                    }, function () {
                      _this.callCallback('onError', _context.t0);
                    });

                  case 17:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this, [[7, 14]]);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }());
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleReset", /*#__PURE__*/function () {
          var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(event) {
            var initialData;
            return _regenerator.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    event && event.preventDefault();
                    initialData = config.initFields(_this.props);

                    _this.setState({
                      formFields: initialiseFormFields(initialData),
                      submitResult: undefined,
                      submitError: undefined,
                      isLoading: false,
                      isPristine: true
                    }, function () {
                      var formData = _this.getFormFieldsValues();

                      _this.callCallback('onReset', formData);
                    });

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          return function (_x2) {
            return _ref3.apply(this, arguments);
          };
        }());
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "formProps", function () {
          var errors = getFormFieldsErrors(_this.state.formFields);
          var hasErrors = objectHasKeys(errors);
          return {
            isLoading: _this.state.isLoading,
            isPristine: _this.state.isPristine,
            submitError: _this.state.submitError,
            submitResult: _this.state.submitResult,
            errors: errors,
            hasErrors: hasErrors,
            fields: _this.state.formFields,
            submit: _this.submit,
            reset: _this.reset,
            updateField: _this.updateField,
            // Event Handlers
            onSubmit: _this.handleSubmit,
            onReset: _this.handleReset,
            // Prop getters
            getInputProps: _this.formInputProps,
            getFieldProps: _this.formFieldProps,
            getFormProps: _this.formComponentProps,
            Form: _this.formComponent
          };
        });

        var _initialData = config.initFields(_props);

        _this.state.formFields = initialiseFormFields(_initialData);
        return _this;
      }

      (0, _createClass2.default)(PragmaticForm, [{
        key: "setState",
        value: function setState(changes, callback) {
          var _this2 = this;

          (0, _get2.default)((0, _getPrototypeOf2.default)(PragmaticForm.prototype), "setState", this).call(this, changes, function () {
            _this2.callCallback('onChange', _this2.getFormFieldsValues);

            if (callback) callback();
          });
        }
      }, {
        key: "callCallback",
        value: function callCallback(name, value) {
          if (typeof callbacks[name] === 'function') {
            if (typeof value === 'function') {
              // Allow lazy value resolution
              callbacks[name](value(), this.props, this.formProps());
            } else {
              callbacks[name](value, this.props, this.formProps());
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, this.props, {
            form: this.formProps()
          }));
        }
      }]);
      return PragmaticForm;
    }(_react.Component), (0, _defineProperty2.default)(_class, "displayName", componentDisplayName), _temp;
  };
}